var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-info"},_vm._l((_vm.items),function(item,index){return _c('FeedbackInput',{key:index,attrs:{"id":item.id,"placeholder":item.text,"text":_vm.data.values.find(it => it.id === item.id)
        ? _vm.data.values.find(it => it.id === item.id).value
        : ''},on:{"updateValue":function($event){return _vm.update()}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }